export default "__VITE_ASSET__BRS1spQg__"